import { selectActivePackageServiceId } from '../../reducers/v2/publicationPackages/selectors/selectActivePackageServiceId';
import { EPlacingType } from '../../types/reducers/publishTerms';
import { selectActivePlacingType } from './selectActivePlacingType';
import { PROMOTION_SERVICES } from '../../constants/services';

import { createSelector } from 'reselect';

export const selectIsPromotionPackageSelected = createSelector(
  [selectActivePackageServiceId, selectActivePlacingType],
  (activePackageServiceId, placingType): boolean => {
    return (
      placingType === EPlacingType.package &&
      !!activePackageServiceId &&
      PROMOTION_SERVICES.includes(activePackageServiceId)
    );
  },
);
